import { createStyles, rem } from "@mantine/core"
import { FacebookIconBlue, LinkedInBlue } from "app/static/frontend/design-constants"

export const useStyles = createStyles((theme) => ({
    linkTypeSection: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: theme.spacing.xs,
    },
    title: {
        color: theme.colors.gray[7],
        fontSize: "0.875rem",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "normal",
    },
    box: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.xl,
        padding: theme.spacing.xl,
        alignItems: "flex-start",
        borderRadius: rem(4),
        backgroundColor: theme.colors.gray[0],
    },
    fbIcon: {
        color: FacebookIconBlue,
        marginRight: rem(6),
    },
    xIcon: {
        marginRight: rem(7),
    },
    linkedinIcon: {
        color: LinkedInBlue,
        marginRight: rem(7),
    },
    linkIcon: {
        color: theme.colors.violet[5],
    },
}))
